import moment from 'moment-timezone'

export function formatDateWithUserTimezone(date: string, format: string, userTimezone?: string) {
  if (!date) return '-'
  return moment(date).tz(userTimezone || moment.tz.guess()).format(format)
} 
